import React from 'react';
import './styles.css';
import Logo from '../../../assets/icons/coinbazaar-logo.svg'; 

const Loader: React.FC = () => (
  <div className='loader w-100 d-flex justify-content-center align-items-center'>
    
    <img src={Logo} alt="CoinBazaar" className="loader-logo" />

    <p className='text-center text-white mt-3'>
      This may take a few seconds, please don&apos;t close this page.
    </p>

  </div>
);

export default Loader;